import React from 'react'
import './getappstorage.scss'
const Getapp = () => {
    return (
        <>
            <section className='getappmainprnt'>
                <div className="custom-container">
                    <div className="getappchldmain">
                        <div className="imgtoppostiongetapp">
                            <img className='img-fluid' src="\assets\Chatandpay\topleftgetapp.png" alt="" />
                        </div>

                        <h6>
                            Secure, Scalable Storage:
                        </h6>
                        <h1>
                            TOMI Meets All Your Data Needs
                        </h1>
                        <p className='tomiparagetapppara'>TOMI's decentralized storage keeps your data safe, scalable, and affordable. Protect data of any size – from personal backups to enterprise archives. Green & flexible! Try Storage today.</p>
                        <div className="getappsocialiconsec">

                            <ul className='getappsocialicon '>
                                <li>
                                    <a href="https://twitter.com/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\TwitterX.svg" alt="TwitterXimg" /></a>
                                </li>
                                <li>
                                    <a href="https://t.me/tomi_official_chat" target='_blank'><img src="\assets\Aboutus\Telegram App.svg" alt="Telegramimg" /></a>
                                </li>
                                <li>
                                    <a href="https://discord.com/invite/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\Discord New.svg" alt="Discordimg" /></a>
                                </li>
                                <li>
                                    <a href="https://medium.com/tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\Medium.svg" alt="Mediumimg" /></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/@tomipioneers" rel="me" target='_blank'><img src="\assets\Aboutus\YouTube.svg" alt="YouTubeimg" /></a>
                                </li>
                            </ul>
                        </div>
                        <div className="imgbottompostiongetapp">
                            <img className='img-fluid' src="\assets\Storageimages\bottomrightgetapp.png" alt="img" />
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Getapp